/**
 * Class that interprets color formats and make operations on them.
 */
export default class ColorConverter {
    static multiply(colorA, colorB) {
        return this.convertToHex(this.multiplyColors(this.interpretText(colorA), this.interpretText(colorB)));
    }
    static multiplyOpacity(color, opacity) {
        const opacityColor = {
            red: 1,
            green: 1,
            blue: 1,
            opacity: opacity
        };
        return this.convertToHex(this.multiplyColors(this.interpretText(color), opacityColor));
    }
    static interpretText(str) {
        if (str.startsWith('rgba(')) {
            const results = /rgba\((.+)\)/g.exec(str)[1];
            const list = results.split(',');
            return {
                // 0 - 255
                red: this.bitsToNumber(list[0]),
                green: this.bitsToNumber(list[1]),
                blue: this.bitsToNumber(list[2]),
                opacity: list.length === 4 ? Number(list[3]) : 1
            };
        }
        if (str.startsWith('#')) {
            if (str.length === 4) {
                // 0 - 16
                return {
                    red: this.hexToNumber(str.substring(1, 2)),
                    green: this.hexToNumber(str.substring(2, 3)),
                    blue: this.hexToNumber(str.substring(3, 4)),
                    opacity: 1
                };
            }
            else if (str.length === 5) {
                // 0 - 16
                return {
                    red: this.hexToNumber(str.substring(1, 2)),
                    green: this.hexToNumber(str.substring(2, 3)),
                    blue: this.hexToNumber(str.substring(3, 4)),
                    opacity: this.hexToNumber(str.substring(4, 5))
                };
            }
            else if (str.length === 7) {
                // 0 - 255
                return {
                    red: this.hexToNumber(str.substring(1, 3)),
                    green: this.hexToNumber(str.substring(3, 5)),
                    blue: this.hexToNumber(str.substring(5, 7)),
                    opacity: 1
                };
            }
            else if (str.length === 9) {
                // 0 - 255
                return {
                    red: this.hexToNumber(str.substring(1, 3)),
                    green: this.hexToNumber(str.substring(3, 5)),
                    blue: this.hexToNumber(str.substring(5, 7)),
                    opacity: this.hexToNumber(str.substring(7, 9))
                };
            }
        }
        throw new Error("Color not in rgba or hex format. Color must start with either 'rgba(' or '#'");
    }
    static convertToHex(color) {
        return ('#' +
            [
                this.numberToHexBits(color.red),
                this.numberToHexBits(color.green),
                this.numberToHexBits(color.blue),
                this.numberToHexBits(color.opacity)
            ].join(''));
    }
    static multiplyColors(a, b) {
        return {
            red: a.red * b.red,
            green: a.green * b.green,
            blue: a.blue * b.blue,
            opacity: a.opacity * b.opacity
        };
    }
    /**
     * E.g. "cc" -> 0.8.
     *
     * @param hex ...
     */
    static hexToNumber(hex) {
        if (hex.length === 2) {
            return parseInt(hex, 16) / 255;
        }
        return parseInt(hex, 16) / 15;
    }
    /**
     * 0 - 255 to 0 - 1.
     *
     * @param bits ...
     */
    static bitsToNumber(bits) {
        return Number(bits) / 255;
    }
    /**
     * E.g. 0.8 -> "cc".
     *
     * @param number ...
     */
    static numberToHexBits(number) {
        const results = Math.round(number * 255).toString(16);
        if (results.length === 1) {
            return '0' + results;
        }
        return results;
    }
}
//# sourceMappingURL=ColorConverter.js.map